import { createFileRoute } from "@tanstack/react-router";
import CommunityLayout from "lib/components/builders/communities/CommunityLayout";
import TasksView from "lib/components/builders/communities/tasks/TasksView";
import { useAppRouterParams } from "lib/routeHelpers";
import withAuthentication from "../../../../../../components/withAuthentication";

function LocationTasksPageReady() {
  const { builderId, locationId } = useAppRouterParams();

  if (!builderId || !locationId) {
    return null;
  }

  return <LocationTasksPage builderId={builderId} locationId={locationId} />;
}

function LocationTasksPage({ builderId, locationId }: { builderId: string; locationId: string }) {
  return (
    <CommunityLayout currentPage="tasks">
      <TasksView builderId={builderId} locationId={locationId} />
    </CommunityLayout>
  );
}

export const Route = createFileRoute("/builders/$builder_id/locations/$location_id/tasks/")({
  component: withAuthentication(LocationTasksPageReady, { features: ["estimationTasks"] }),
});
